import { useEffect, useState, useSyncExternalStore } from "react";
import { Link, useLocation } from "react-router-dom";
import { getStoredConsent, setStoredConsent } from "@/lib/thirdPartyAnalytics";

// Tiny shared store so the WhatsApp FAB can lift itself above the banner
// while it is on screen (mockup: bottom 26px → 110px).
let bannerVisible = false;
const listeners = new Set<() => void>();
const setBannerVisible = (v: boolean) => {
  if (bannerVisible === v) return;
  bannerVisible = v;
  listeners.forEach((l) => l());
};
export function useConsentBannerVisible() {
  return useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    () => bannerVisible,
    () => false,
  );
}

export function AnalyticsConsentBanner() {
  const location = useLocation();
  const [visible, setVisible] = useState(() => getStoredConsent() === null);
  // Token-gated client pages (sign/pay/feedback) and the OAuth consent screen are
  // transactional, not marketing — no analytics runs there, so no consent prompt either.
  const hidden = !visible || /^\/(admin|sign|pay|feedback|oauth)(\/|$)/.test(location.pathname);

  useEffect(() => {
    setBannerVisible(!hidden);
    return () => setBannerVisible(false);
  }, [hidden]);

  if (hidden) return null;

  const choose = (value: "granted" | "denied") => {
    setStoredConsent(value);
    setVisible(false);
  };

  return (
    <div className="fixed inset-x-0 bottom-0 z-[45] border-t border-border bg-card px-5 py-4 shadow-[0_-8px_30px_-18px_rgba(18,20,30,.4)]">
      <div className="mx-auto flex max-w-[1180px] flex-wrap items-center gap-5">
        <p className="min-w-[260px] flex-1 text-[13px] leading-[1.6] text-muted-foreground">
          Uso cookies (Google Analytics e Meta Pixel) só para entender quais páginas ajudam de fato.
          Nada de rastreamento entre sites.{" "}
          <Link to="/politica-de-privacidade" className="text-primary hover:text-primary-deep">
            Política de privacidade
          </Link>
          .
        </p>
        <div className="flex gap-[9px]">
          <button
            type="button"
            onClick={() => choose("denied")}
            className="h-10 rounded-[10px] border border-border bg-card px-[17px] text-[13px] font-semibold text-muted-foreground transition hover:brightness-[.94]"
          >
            Recusar
          </button>
          <button
            type="button"
            onClick={() => choose("granted")}
            className="h-10 rounded-[10px] bg-primary px-[19px] text-[13px] font-bold text-primary-foreground transition hover:brightness-[.94]"
          >
            Aceitar
          </button>
        </div>
      </div>
    </div>
  );
}
